import { useDatasetsMutatorStatus } from "@/modules/datasets/datasets-mutator";
import { useInterventionSectionContext } from "@/modules/intervention/intervention-section-context";
import ObservationInvalidationButton from "@/modules/observation/observation-invalidation-button";
import ObservationValidationButton from "@/modules/observation/observation-validation-button";
import ObservationValidationTag from "@/modules/observation/observation-validation-tag";

import "./intervention-section-card-extra.style.less";

const InterventionSectionCardExtra = () => {
  const { isDirty, isSaving } = useDatasetsMutatorStatus();
  const { observation, isEditable, intervention, observationQuery } =
    useInterventionSectionContext();

  const loading = observationQuery.isLoading;
  const disabled = isDirty || isSaving;

  const validation = observation?.validation;

  const invalidateKeys = [["interventions", "menu", intervention.id]];

  return (
    <div className="intervention-section-card-extra">
      <ObservationValidationTag observation={observation} />
      {isEditable && observation && !validation && (
        <ObservationValidationButton
          observationId={observation.id}
          disabled={disabled}
          loading={loading}
          invalidateKeys={invalidateKeys}
        />
      )}
      {isEditable && validation && (
        <ObservationInvalidationButton
          observationId={observation.id}
          disabled={disabled}
          loading={loading}
          invalidateKeys={invalidateKeys}
        />
      )}
    </div>
  );
};

export default InterventionSectionCardExtra;
